import type { MouseEvent } from "react";
import { Chooser } from "./Chooser";
import { labHref, parseLabSearch, type DirectorState, type LabScreen } from "./types";
import { DawnWorld } from "./worlds/dawn";
import { LampWorld } from "./worlds/lamp";
import { PocketWorld } from "./worlds/pocket";

export function LabView({
  search,
  basePath,
  onTraverse,
}: {
  search: string;
  basePath: string;
  director: DirectorState;
  onDirector: (patch: Partial<DirectorState>) => void;
  onTraverse?: (href: string, event: MouseEvent<HTMLAnchorElement>) => void;
}) {
  const { design, screen } = parseLabSearch(search);
  const hrefFor = (next: LabScreen) => labHref(basePath, design, next);
  const world = { screen, basePath, hrefFor, onTraverse };

  if (design === "dawn") return <DawnWorld {...world} />;
  if (design === "pocket") return <PocketWorld {...world} />;
  if (design === "lamp") return <LampWorld {...world} />;
  return <Chooser basePath={basePath} onTraverse={onTraverse} />;
}
